import React from "react";
import moment from "moment";
import {
	Link, Redirect
}
from "react-router-dom";
import {
	getData
}
from "../../services/index";
import {
	Drawer,
	Upload,
	Modal,
	message,
	Collapse,
	Radio,
	Checkbox,
	label,
	Input,
	Popover,
	Button,
	Tooltip,
	TimePicker,
	Select,
}
from "antd";
import {
	PlusOutlined,
	PictureOutlined,
	VideoCameraOutlined,
	FileOutlined,
	FileImageOutlined,
	CloseOutlined,
	AudioOutlined,
}
from "@ant-design/icons";

import ModalImage from "react-modal-image";
import axios from "axios";
import $ from "jquery";
import attached from "../../assets/images/icon/paperclip.png";
import load from "../../assets/images/icon/load.gif";
import music from "../../assets/images/icon/music.png";
import pdf_ from "../../assets/images/icon/pdf_.png";
import image from "../../assets/images/icon/image.png";
import person from "../../assets/images/icon/person.png";

const {
	TextArea
} = Input;
const {
	Panel
} = Collapse;
const buttonWidth = 70;
const selected_student = [];

function callback(key) {
	console.log(key);
}

function onChange(time, timeString) {
	console.log(time, timeString);
}

function onChangechecked(checkedValues) {
	console.log("checked = ", checkedValues);
}

function getBase64(file) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result);
		reader.onerror = (error) => reject(error);
	});
}

const storedFiles = [];
const storedFilespdf = [];
const storedFilesaudio = [];

var uni_id = new Date().getTime();
const class_array = [
  { id: uni_id, subject_id: "",task: "", note: "", file:""},
];

class Index extends React.Component {
	static contextTypes = {
		router: () => null,
	};
	constructor(props) {
		super(props);
		this.state = {
			size: "default",
			quant: "default",
			like_type: "default",
			comment_type: "default",
			notification_type: "default",
			value: "",
			communication_type: "",
			academic_year: "",
			year_list: [],
			details: "",
			details: "",
			image: "",
			video: "",
			file: "",
			loading: false,
			iconLoading: false,
			children_id: [],
			class_id: [],
			previewVisible: false,
			Program: false,
			previewImage: "",
			previewTitle: "",
			selected_program_1: "",
			fileList: [],
			school_list: [],
			selected_class: [],
			selected_student: [],
			selected_student_data: [],
			selected_program: [],
			program_list: [],
			program_id: [],
			dchecked: false,
			checked: false,
			checkedBoxes: [],
			dcheckedBoxes: [],
			selectedFiles: null,
			previewImage: "",
			previewTitle: "",
			previewVisible: false,
			file_list: [],
			file_list_pdf: [],
			file_list_audio: [],
			mobile_child: false,
			mobile_class: false,
			tag_name: [],
			selected_div_data: [],
			selected_div: [],
			division_list: [],
			division: "",
			values: [1],
			subject_list: [],
			selected_row: 0,
			class_array: class_array,
		};
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.goBack = this.goBack.bind(this);
		this.handleClickProgram = this.handleClickProgram.bind(this);
		this.onChangechecked = this.onChangechecked.bind(this);
	}
	
	showDrawer = () => {
		this.setState({
			mobile_child: true,
		});
	}
	
	onClose = () => {
		this.setState({
			mobile_child: false,
		});
	}
	
	showDrawerClass = () => {
		this.setState({
			mobile_class: true,
		});
	}
	
	onCloseClass = () => {
		this.setState({
			mobile_class: false,
		});
	}
	
	onChangechecked(checkedValues) {
		console.log("checked = ", checkedValues);
		this.setState({
			program: checkedValues
		});
	}
	
	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem("schoolData")) {
			localStorage.setItem("schoolData", "");
			localStorage.clear();
			window.location.href = "/login";
		} else {
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			this.setState({
				user_id: storedArray["data"][0]["user_id"],
				school_id: storedArray["data"][0]["school_id"],
			});
			this.checkData();
		}
	}
	
	checkData() {
		if(localStorage.getItem("schoolData")) {
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			this.setState({
				user_id: storedArray["data"][0]["user_id"],
				school_id: storedArray["data"][0]["school_id"],
				staff_id: this.props.match.params.id,
			});
			var user_id = storedArray["data"][0]["user_id"];
			var school_id = storedArray["data"][0]["school_id"];
			var type = storedArray["data"][0]["type"];
			var tag_type = 6;
			var app = {
				user_id: user_id,
				program_id: this.state.program,
				school_id: school_id,
				division: this.state.selected_div,
				type: type,
			};
			getData("erp/student_list_3", app).then((result) => {
				let responseJson = result;
				if(responseJson.data) {
					if(result["status"] == 200) {
						this.setState({
							school_list: result["data"],
						});
					} else {
						this.setState({
							school_list: [],
						});
					}
				}
			});
			getData("erp/multi_division_list_by_class", app).then((result) => {
				let responseJson = result;
				if(responseJson.data) {
					if(result["status"] == 200) {
						this.setState({
							division_list: result["data"],
						});
					} else {
						this.setState({
							division_list: [],
						});
					}
				}
			});
			getData("erp/new_program_list", app).then((result) => {
				let responseJson = result;
				if(responseJson.data) {
					if(result["status"] == 200) {
						this.setState({
							program_list: result["data"],
						});
					} else {
						this.setState({
							program_list: [],
						});
					}
				}
			});
			var app_2 = {
				user_id: user_id,
				program_id: this.state.program,
				school_id: school_id,
				type: tag_type,
			};
			getData("erp/tag_details", app_2).then((result) => {
				let responseJson = result;
				if(responseJson.data) {
					if(result["status"] == 200) {
						this.setState({
							tag_name: result["data"],
						});
					} else {
						this.setState({
							school_list: [],
							tag_name: "",
						});
					}
				}
			});
			getData('Timetable/subject_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							subject_list: result['data'],
						});
					}else{
						this.setState({
							subject_list: [],
						});
					}
				}
			});
			getData('common/get_academic_year',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							year_list: result['data'],
							academic_year: result['current_year'],
						});
					}else{
						this.setState({
							year_list: [],
							academic_year : ""
						});
					}
				}
			});
		}
	}
	
	get_selected_student() {
		if(this.state.selected_student.length == 0) {
			this.setState({
				selected_student_data: [],
			});
		}
		var app2 = {
			user_id: this.state.selected_student
		};
		getData("erp/student_list_selected", app2).then((result) => {
			let responseJson2 = result;
			if(responseJson2.data) {
				if(result["status"] == 200) {
					this.setState({
						selected_student_data: result["data"],
					});
				} else {
					this.setState({
						selected_student_data: [],
					});
				}
			}
		});
	}
	
	handleSizeChange = (e) => {
		this.setState({
			[e.target.name]: e.target.value
		});
	}
	
	handleSubmit = (e) => {
		e.preventDefault();
		if(localStorage.getItem("schoolData")) {
			if(this.state.children_id != "") {
				this.setState({
					loading: true
				});
				document.getElementById("loader").classList.add("d-block");
				var app = {
					user_id: this.state.user_id,
					program: this.state.program,
					division: this.state.selected_div,
					children_id: this.state.children_id,
					communication_type: this.state.communication_type,
					academic_year: this.state.academic_year,
					like_type: this.state.like_type,
					comment_type: this.state.comment_type,
					notification_type: this.state.notification_type,
					details: this.state.details,
					image: this.state.image,
					video: this.state.video,
					file: this.state.file,
					school_id: this.state.school_id,
				};
				getData("erp/add_diary", app).then((result) => {
					if(result.status == 400) {
						message.config({
							top: 150
						});
						message.error("Please Insert All Field", 2);
						this.setState({
							loading: false
						});
						document.getElementById("loader").classList.remove("d-block");
					}
					if(result.status == 200) {
						message.config({
							top: 150
						});
						const data = new FormData();
						
						
						
						if(this.state.communication_type== "Class work" || this.state.communication_type== "Home Work"){
							
							const class_array = this.state.class_array;
							
							for(let i = 0; i < class_array.length; i++) {
								data.append(`subject_id[${i}]`, class_array[i].subject_id);
								data.append(`task[${i}]`, class_array[i].task);
								data.append(`note[${i}]`, class_array[i].note);
								data.append(`file[${i}]`, class_array[i].file);
							}
							
							data.append("id", result.id);
							data.append("type", "dairy");
							data.append("user_id", this.state.user_id);
							
							let url = "https://kcisapi.kidzonia.co.in/v1/erp/upload_diary_homework_file";
							axios.post(url, data, {}).then((res) => {
								this.setState({
									loading: true
								});
								message.config({
									top: 150
								});
								message.success("Dairy added", 2);
								this.sendFcmNotification(result.id);
								this.setState({
									loading: false
								});
								window.location.reload(false);
							});
						}else{
							const selectedFiles = this.state.file_list;
							const selectedFilespdf = this.state.file_list_pdf;
							const selectedFilesaudio = this.state.file_list_audio;
							
							const image = [];
							const pdf = [];
							const audio = [];
							
							if(selectedFiles.length == 0) {
								data.append(`image[0]`, "[]");
							}
							if(selectedFilespdf.length == 0) {
								data.append(`pdf[0]`, "[]");
							}
							if(selectedFilesaudio.length == 0) {
								data.append(`audio[0]`, "[]");
							}
							for(let i = 0; i < selectedFiles.length; i++) {
								data.append(`image[${i}]`, selectedFiles[i].selectedFiles);
							}
							for(let i = 0; i < selectedFilespdf.length; i++) {
								data.append(`pdf[${i}]`, selectedFilespdf[i].storedFilespdf);
							}
							for(let i = 0; i < selectedFilesaudio.length; i++) {
								data.append(`audio[${i}]`, selectedFilesaudio[i].storedFilesaudio);
							}
							data.append("id", result.id);
							data.append("type", "dairy");
							data.append("user_id", this.state.user_id);
							let url = "https://kcisapi.kidzonia.co.in/v1/erp/upload_attached_file";
							axios.post(url, data, {}).then((res) => {
								this.setState({
									loading: true
								});
								message.config({
									top: 150
								});
								message.success("Dairy added", 2);
								this.sendFcmNotification(result.id);
								this.setState({
									loading: false
								});
								window.location.reload(false);
							});
						}
					}
				});
			} else {
				message.error("Please Select Child", 2);
				document.getElementById("loader").classList.remove("d-block");
			}
		} else {
			message.error("Please Login", 2);
		}
	}
	
	sendFcmNotification = (module_id) => {
		var app = {
			module_id:module_id
		};
		getData("cron/send_fcm_notification_by_id", app).then((result) => {
			let responseJson = result;
			if(responseJson) {
				if(result["status"] == 200) {
					
				}
			}
		});
	}
	
	handleCancel = () => this.setState({
		previewVisible: false
	});
	
	handlePreview = async(file) => {
		if(!file.url && !file.preview) {
			file.preview = await getBase64(file.originFileObj);
		}
		this.setState({
			previewImage: file.url || file.preview,
			previewVisible: true,
			previewTitle: file.name || file.url.substring(file.url.lastIndexOf("/") + 1),
		});
	}
	
	showModal = () => {
		this.setState({
			staff: true,
		});
	}
	
	showchildModal = () => {
		this.setState({
			child: true,
		});
	}
	
	handleOk = (e) => {
		this.get_selected_student();
		console.log(e);
		this.setState({
			child: false,
			staff: false,
			mobile_child: false,
		});
	}
	
	handleCancel = (e) => {
		console.log(e);
		this.setState({
			child: false,
			staff: false,
		});
	}
	
	handleChange = ({
		fileList
	}) => this.setState({
		fileList
	});
	
	handleClick(event) {
		const target = event.target;
		var value = target.value;
		console.log(value);
		if(target.checked) {
			this.state.selected_student[value] = value;
			this.state.children_id[value] = value;
		} else {
			this.state.selected_student.splice(value, 1);
			this.state.children_id.splice(value, 1);
		}
		console.log(this.state.selected_student);
		//this.checkData();
	}
	
	get_selected_program() {
		if(this.state.program.length == 0) {
			this.setState({
				selected_program: [],
			});
		}
		this.setState({
			selected_student_data: [],
			selected_student: [],
		});
		var app2 = {
			user_id: this.state.program
		};
		getData("erp/program_list_selected", app2).then((result) => {
			let responseJson2 = result;
			if(responseJson2.data) {
				if(result["status"] == 200) {
					this.setState({
						selected_program: result["data"],
					});
				} else {
					this.setState({
						selected_program: [],
					});
				}
			}
		});
		setTimeout(() => {
			this.checkData();
		}, 300);
	}
	
	handleClickProgram(event) {
		const target = event.target;
		var value = target.value;
		console.log(value);
		if(target.checked) {
			this.state.selected_program_1 = value;
			this.state.program_id = value;
		} else {
			this.state.selected_program = "";
			this.state.program_id = "";
		}
		console.log(this.state.selected_program);
		this.checkData();
	}
	
	showModalProgram = () => {
		this.setState({
			Program: true,
		});
	}
	
	handleOkProgram = (e) => {
		this.get_selected_program();
		console.log(e);
		this.setState({
			Program: false,
			mobile_class: false,
		});
	}
	
	handleCancelProgram = (e) => {
		console.log(e);
		this.setState({
			Program: false,
		});
	}
	
	dtoggleChecked = () => {
		const dcheckedBoxes = [...this.state.dcheckedBoxes];
		var checkboxes = document.getElementsByName("class_id[]");
		for(var i = 0; i < checkboxes.length; i++) {
			dcheckedBoxes.push(checkboxes[i].value);
		}
		this.setState({
			program: dcheckedBoxes,
			dcheckedBoxes,
			dchecked: true,
			dselection_count: dcheckedBoxes.length,
			selected_class: dcheckedBoxes,
			class_id: dcheckedBoxes,
		});
	}
	
	dtoggleUnChecked = () => {
		const dcheckedBoxes = [...this.state.dcheckedBoxes];
		this.setState({
			dcheckedBoxes: [],
			program: [],
			dchecked: false,
			dselection_count: 0,
			selected_class: [],
			class_id: [],
		});
	}
	
	dhandleCheckbox = (e, s) => {
		const dcheckedBoxes = [...this.state.dcheckedBoxes];
		if(e.target.checked) {
			dcheckedBoxes.push(s);
		} else {
			const index = dcheckedBoxes.findIndex((ch) => ch === s);
			dcheckedBoxes.splice(index, 1);
		}
		console.log("program: ", dcheckedBoxes);
		this.setState({
			program: dcheckedBoxes,
			dcheckedBoxes,
			dselection_count: dcheckedBoxes.length,
			selected_class: dcheckedBoxes,
			class_id: dcheckedBoxes,
		});
	}
	
	toggleChecked = () => {
		const checkedBoxes = [...this.state.checkedBoxes];
		var checkboxes = document.getElementsByName("checked_id[]");
		for(var i = 0; i < checkboxes.length; i++) {
			checkedBoxes.push(checkboxes[i].value);
		}
		this.setState({
			checkedBoxes,
			checked: true,
				selection_count: checkedBoxes.length,
				selected_student: checkedBoxes,
				children_id: checkedBoxes,
		});
		console.log(checkedBoxes);
	}
	
	toggleUnChecked = () => {
		const checkedBoxes = [...this.state.checkedBoxes];
		this.setState({
			checkedBoxes: [],
			checked: false,
			selection_count: 0,
			selected_student: [],
			children_id: [],
		});
	}
	
	handleCheckbox = (e, s) => {
		const checkedBoxes = [...this.state.checkedBoxes];
		if(e.target.checked) {
			checkedBoxes.push(s);
		} else {
			const index = checkedBoxes.findIndex((ch) => ch === s);
			checkedBoxes.splice(index, 1);
		}
		this.setState({
			checkedBoxes,
			selection_count: checkedBoxes.length,
				selected_student: checkedBoxes,
				children_id: checkedBoxes,
		});
	}
	
	handleFileSelect = (e) => {
		var files = e.target.files;
		var people = [];
		var filesArr = Array.prototype.slice.call(files);
		filesArr.forEach(function(f) {
			if(storedFiles.length > 3) {
				message.config({
					top: 150
				});
				message.error("Sorry!..You can upload maximum 10 files at a time", 2);
			} else {
				var _size = f.size;
				if(_size > 4100000) {
					message.config({
						top: 150
					});
					message.error("Sorry!..You Can't Upload more then 4MB!", 2);
					return false;
				}
				var reader = new FileReader();
				reader.onload = function(e) {
					var name = f.type;
					var t = name.toString().split("/");
					//if (t[0] === 'image') {
					var app = {
						file_name: f.name,
						file_url: e.target.result,
						file_type: "image",
						selectedFiles: f,
					};
					storedFiles.push(app);
					people.push(f);
					// }
				};
				reader.readAsDataURL(f);
			}
		});
		setTimeout(() => {
			this.setState({
				file_list: storedFiles
			});
		}, 500);
	}
	
	removeFile = (file, e) => {
		for(var i = 0; i < storedFiles.length; i++) {
			if(storedFiles[i].file_name === file) {
				storedFiles.splice(i, 1);
				break;
			}
		}
		setTimeout(() => {
			if(storedFiles.length == "0") {
				const file = document.querySelector(".file");
				file.value = "";
			}
			this.setState({
				file_list: storedFiles
			});
			//console.log(storedFiles);
		}, 500);
	}
	
	handleFileSelectpdf = (e) => {
		var files = e.target.files;
		var people = [];
		var filesArr = Array.prototype.slice.call(files);
		filesArr.forEach(function(f) {
			if(storedFilespdf.length > 3) {
				message.config({
					top: 150
				});
				message.error("Sorry!..You can upload maximum 10 files at a time", 2);
				document.getElementById("audio").value = "";
				return false;
			} else {
				var _size = f.size;
				if(_size > 4100000) {
					message.config({
						top: 150
					});
					message.error("Sorry!..You Can't Upload more then 4MB!", 2);
					document.getElementById("audio").value = "";
					return false;
				}
				var reader = new FileReader();
				reader.onload = function(e) {
					var name = f.type;
					var t = name.toString().split("/");
					//if (t[0] === 'image') {
					var app = {
						file_name: f.name,
						file_url: e.target.result,
						file_type: "pdf",
						storedFilespdf: f,
					};
					storedFilespdf.push(app);
					people.push(f);
					// }
				};
				reader.readAsDataURL(f);
			}
		});
		setTimeout(() => {
			this.setState({
				file_list_pdf: storedFilespdf
			});
		}, 500);
	}
	
	removeFilepdf = (file, e) => {
		for(var i = 0; i < storedFilespdf.length; i++) {
			if(storedFilespdf[i].file_name === file) {
				storedFilespdf.splice(i, 1);
				break;
			}
		}
		setTimeout(() => {
			if(storedFilespdf.length == "0") {
				const file = document.querySelector(".file");
				file.value = "";
			}
			this.setState({
				file_list_pdf: storedFilespdf
			});
			//console.log(storedFilespdf);
		}, 500);
	}
	
	handleFileSelectaudio = (e) => {
		//alert('hi');
		
		console.log(e.target.files);
		var files = e.target.files;
		var people = [];
		var filesArr = Array.prototype.slice.call(files);
		//console.log(filesArr);
		filesArr.forEach(function(f) {
			if(storedFilesaudio.length > 3) {
				message.config({
					top: 150
				});
				message.error("Sorry!..You can upload maximum 10 files at a time", 2);
				files = [];
				this.setState({
					file_list_audio: []
				});
			} else {
				var _size = f.size;
				if(_size > 4100000) {
					message.config({
						top: 150
					});
					message.error("Sorry!..You Can't Upload more then 4MB!", 2);
					console.log(_size);
					return false;
					files = [];
					this.setState({
						file_list_audio: []
					});
				}
				var reader = new FileReader();
				reader.onload = function(e) {
					var name = f.type;
					var t = name.toString().split("/");
					//if (t[0] === 'image') {
					var app = {
						file_name: f.name,
						file_url: e.target.result,
						file_type: "audio",
						storedFilesaudio: f,
					};
					storedFilesaudio.push(app);
					people.push(f);
					// }
				};
				reader.readAsDataURL(f);
			}
		});
		setTimeout(() => {
			console.log(storedFilesaudio);
			this.setState({
				file_list_audio: storedFilesaudio
			});
		}, 500);
	}
	
	removeFileaudio = (file, e) => {
		for(var i = 0; i < storedFilesaudio.length; i++) {
			if(storedFilesaudio[i].file_name === file) {
				storedFilesaudio.splice(i, 1);
				break;
			}
		}
		setTimeout(() => {
			if(storedFilesaudio.length == "0") {
				const file = document.querySelector(".file");
				file.value = "";
			}
			this.setState({
				file_list_audio: storedFilesaudio
			});
			//console.log(storedFilesaudio);
		}, 500);
	}
	
	goBack() {
		window.location.href = "/";
	}
	
	showModal1 = () => {
		this.setState({
			div: true,
		});
	}
	
	handleOk1 = (e) => {
		this.get_selected_student1();
		console.log(e);
		this.setState({
			child: false,
			staff: false,
			div: false,
			mobile_child: false,
		});
	}
	
	handleCancel1 = (e) => {
		console.log(e);
		this.setState({
			child: false,
			staff: false,
			div: false,
		});
	}
	
	get_selected_student1() {
		if(this.state.selected_div.length == 0) {
			this.setState({
				selected_div_data: [],
			});
		}
		var app2 = {
			user_id: this.state.selected_div
		};
		getData("erp/division_list_selected", app2).then((result) => {
			let responseJson2 = result;
			if(responseJson2.data) {
				if(result["status"] == 200) {
					this.setState({
						selected_div_data: result["data"],
					});
				} else {
					this.setState({
						selected_div_data: [],
					});
				}
			}
			setTimeout(() => {
				this.checkData();
			}, 300);
		});
	}
	
	toggleChecked1 = () => {
		const selected_div = [...this.state.selected_div];
		var checkboxes = document.getElementsByName("division_id[]");
		for(var i = 0; i < checkboxes.length; i++) {
			selected_div.push(checkboxes[i].value);
		}
		this.setState({
			selected_div,
			checked2: true,
				selection_count: selected_div.length,
				selected_div: selected_div,
				selected_div: selected_div,
		});
	}
	
	toggleUnChecked1 = () => {
		const selected_div = [...this.state.selected_div];
		this.setState({
			selected_div: [],
			checked2: false,
			selection_count: 0,
			selected_div: [],
			selected_div: [],
		});
	}
	
	handleCheckbox1 = (e, s) => {
		const selected_div = [...this.state.selected_div];
		if(e.target.checked) {
			selected_div.push(s);
		} else {
			const index = selected_div.findIndex((ch) => ch === s);
			selected_div.splice(index, 1);
		}
		this.setState({
			selected_div,
			selection_count: selected_div.length,
				selected_div: selected_div,
				children_id: selected_div,
		});
	}

	
	
	addRow = (current_row) => {
		var flag = 0;
		for (var i = 0; i < class_array.length; i++) {
		  if (class_array[i].subject_id == "") {
			message.config({ top: 150 });
			message.error("Please select subject", 2);
			return false;
			flag = 1;
			break;
		  }
		}
		setTimeout(() => {
		  if (flag == 0) {
			var uni_id = new Date().getTime();
			var row = {
			  id: uni_id,
			  subject_id: "",
			  task: "",
			  note: "",
			  file: ""
			};

			class_array.push(row);
			this.setState({
			  row_id: uni_id,
			  selected_row: uni_id,
			  class_array: class_array,
			});
		  }
		}, 100);
	};

	removeRow = (current_row) => {
		if (class_array.length == 1) {
		  message.config({ top: 150 });
		  message.error("Alert! Atleast 1 Subject is Required", 2);
		  return false;
		} else {
		  for (var i = 0; i < class_array.length; i++) {
			if (class_array[i].id === current_row) {
			  class_array.splice(i, 1);
			  break;
			}
		  }
		  this.setState({
			class_array: class_array,
		  });
		}
	};
	
	change_subject(current_row, subject_id) {
		for (var i = 0; i < class_array.length; i++) {
		  if (current_row == class_array[i].id) {
			class_array[i].subject_id = subject_id;
			this.setState({
			  class_array: class_array,
			});
			break;
		  }
		}
	}
	
	change_task(current_row, task) {
		for (var i = 0; i < class_array.length; i++) {
		  if (current_row == class_array[i].id) {
			class_array[i].task = task;
			this.setState({
			  class_array: class_array,
			});
			break;
		  }
		}
	}
	
	change_note(current_row, note) {
		for (var i = 0; i < class_array.length; i++) {
		  if (current_row == class_array[i].id) {
			class_array[i].note = note.target.value;
			this.setState({
			  class_array: class_array,
			});
			break;
		  }
		}
	}
	
	change_file(current_row, file) {
		for (var i = 0; i < class_array.length; i++) {
		  if (current_row == class_array[i].id) {
		    var size = file.target.files[0].size;
			if(size > 4100000) {
				message.config({ top: 150 });
				message.error("Sorry!..You Can't Upload more then 4MB!", 2);
				return false;
			}else{
				class_array[i].file = file.target.files[0];
				$('#file_preview_'+current_row).html('1 file selected');
				this.setState({
				  class_array: class_array,
				});
				break;
			}
		  }
		}
	}
	
    render() {
    const { size } = this.state;
    const { previewVisible, previewImage, fileList, previewTitle } = this.state;
    const content = (
      <div>
        <p className="center upload-img ant-upload-text">
          <Tooltip placement="right" title="Audio">
            <label tabindex="0" class="pointer" role="button" for="audio">
              <img src={music} className="pointer" />
              <input
                onChange={this.handleFileSelectaudio}
                class="file-upload__input file hide"
                type="file"
                name="files"
                id="audio"
                accept="audio/*"
                multiple="multiple"
                style={{ display: "none", opacity: "0" }}
              />
            </label>
          </Tooltip>
        </p>
        <p className="center upload-img">
          <Tooltip placement="right" title="Pdf">
            <label tabindex="0" class="pointer" role="button" for="pdf">
              <img src={pdf_} className="pointer" />
              <input
                onChange={this.handleFileSelectpdf}
                class="file-upload__input file hide"
                type="file"
                name="files"
                id="pdf"
                accept=".pdf"
                multiple="multiple"
                style={{ display: "none", opacity: "0" }}
              />
            </label>
          </Tooltip>
        </p>
        <p className="center upload-img">
          <Tooltip placement="right" title="Image">
            <label tabindex="0" class="pointer" role="button" for="image">
              <img src={image} className="pointer" />
              <input
                onChange={this.handleFileSelect}
                class="file-upload__input file hide"
                type="file"
                name="files"
                id="image"
                accept="image/*"
                multiple="multiple"
                style={{ display: "none", opacity: "0" }}
              />
            </label>
          </Tooltip>
        </p>
      </div>
    );
    const radioStyle = {
      display: "block",
      height: "30px",
      lineHeight: "30px",
    };
    const uploadButton = (
      <div>
        <PlusOutlined />
        <div className="ant-upload-text">Upload</div>
      </div>
    );
    return (
      <div class="mobile_view">
        <div class="row bred">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <h4 class="page-title">
                  <i class="mdi mdi-apple-keyboard-command title_icon"></i>Add
                  Diary
                  <div class="breadcrumb-wrapper">
                    <ol class="breadcrumb">
                      <li class="breadcrumb-item">
                        <a
                          href={`${process.env.PUBLIC_URL}/`}
                          class="router-link-active"
                          target="_self"
                        >
                          <img
                            src="https://erp.kidzonia.co.in/panel/assets/icons/home.png"
                            className="home-img"
                          />
                        </a>
                      </li>
                      <li class="breadcrumb-item">
                        <a
                          href={`https://erp.kidzonia.co.in/panel/admin/diary-list`}
                          class="router-link-active"
                          target="_self"
                        >
                          Diary
                        </a>
                      </li>
                      <li class="breadcrumb-item"> Add Diary </li>
                    </ol>
                  </div>
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div id="main" class="bg-off">
          <div class="row">
            <div class="col-md-12 ex-padd">
              <div class="">
                <div class="col-md-12 mb-20 mt-10 card-content iq-card">
                  <div class="div-loader" id="loader">
                    <img src={load} /> File Uploading Please Wait !!!
                  </div>
                  <section class="invoice-list-wrapper section food ">
					
					<div class="children bg-blue communication iq-card2 mb-20">
                      <Collapse defaultActiveKey={["1"]} onChange={callback}>
                        <Panel header="Academic Year" key="1">
                          <Radio.Group
                            value={this.state.academic_year} 
                            name="academic_year"
                            onChange={this.handleSizeChange}
                          >
                            {this.state.year_list.map((list) => (
                              <Radio.Button
                                value={list.name}
                                id={`tag_${list.id}`}
                              >
                                {" "}
                                <label for={`tag_${list.id}`}>
                                  {list.name}
                                </label>
                              </Radio.Button>
                            ))}
                          </Radio.Group>
                        </Panel>
                      </Collapse>
                    </div> 
					
                    <div class="desktop-view">
                      <div class=" children   mb-20 iq-card2">
                        <Collapse defaultActiveKey={["1"]} onChange={callback}>
                          <Panel header="Programs" classname="as" key="1">
                            <Button
                              className="snd-btn"
                              onClick={this.showModalProgram}
                            >
                              {" "}
                              Select Program
                            </Button>
                            <div class="children bg-blue attendance">
                              <Checkbox.Group name="children_id[]">
                                {this.state.selected_program.map((list) => (
                                  <Checkbox
                                    value={list.id}
                                    id={`category_id_${list.id}`}
                                    defaultChecked={true}
                                    disabled
                                  >
                                    <label class="w-m" for={list.id}>
                                      <div class="center">{list.name} </div>
                                    </label>
                                  </Checkbox>
                                ))}
                              </Checkbox.Group>
                            </div>
                            <Modal
                              title="Select Program"
                              visible={this.state.Program}
                              onOk={this.handleOkProgram}
                              onCancel={this.handleCancelProgram}
                            >
                              <div class="children bg-blue communication popup row">
                                <div class="col-md-12">
                                  {(() => {
                                    if (this.state.dchecked == true) {
                                      return (
                                        <>
                                          <Checkbox
                                            onClick={this.dtoggleUnChecked.bind(
                                              this
                                            )}
                                            checked="checked"
                                            id="alls"
                                          >
                                            <label
                                              for="alls"
                                              className="select-all"
                                            >
                                              UNSELECT All{" "}
                                            </label>
                                          </Checkbox>
                                        </>
                                      );
                                    } else {
                                      return (
                                        <>
                                          <Checkbox
                                            onClick={this.dtoggleChecked.bind(
                                              this
                                            )}
                                            checked=""
                                            id="alls"
                                          >
                                            <label
                                              for="alls"
                                              className="select-all"
                                            >
                                              SELECT All{" "}
                                            </label>
                                          </Checkbox>
                                        </>
                                      );
                                    }
                                  })()}
                                </div>
                                <div class="row">
                                  {this.state.program_list.map((list) => (
                                    <div class="col-md-3 d-contents mob-d-block">
                                      <Checkbox
                                        name="class_id[]"
                                        value={list.id}
                                        id={list.id}
                                        checked={this.state.dcheckedBoxes.find(
                                          (ch) => ch === list.id
                                        )}
                                        onChange={(e) =>
                                          this.dhandleCheckbox(e, list.id)
                                        }
                                      >
                                        <label
                                          for={list.id}
                                          className="checked"
                                        >
                                          <div class="center">{list.name}</div>
                                        </label>
                                      </Checkbox>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </Modal>
                          </Panel>
                        </Collapse>
                      </div>
					  
                      <div class="children mb-20 iq-card2">
                        <Collapse defaultActiveKey={["1"]} onChange={callback}>
                          <Panel header="Division" classname="as" key="1">
                            <Button
                              className="snd-btn"
                              onClick={this.showModal1}
                            >
                              Select Division
                            </Button>
                            <div class="children bg-blue attendance">
                              <Checkbox.Group name="children_id[]">
                                {this.state.selected_div_data.map((list) => (
                                  <Checkbox
                                    value={list.id}
                                    id={list.id}
                                    defaultChecked={true}
                                    disabled
                                  >
                                    <label class="w-m" for={list.id}>
                                      <div class="center">{list.name}</div>
                                    </label>
                                  </Checkbox>
                                ))}
                              </Checkbox.Group>
                            </div>
                            <Modal
                              title="Select Division"
                              visible={this.state.div}
                              onOk={this.handleOk1}
                              onCancel={this.handleCancel1}
                              className="children-model"
                            >
                              <div class="children bg-blue attendance">
                                <div class="col-md-12">
                                  {(() => {
                                    if (this.state.checked2 == true) {
                                      return (
                                        <>
                                          <Checkbox
                                            onClick={this.toggleUnChecked1.bind(
                                              this
                                            )}
                                            checked="checked"
                                            id="all1"
                                          >
                                            <label
                                              for="all1"
                                              className="select-all"
                                            >
                                              UNSELECT All{" "}
                                            </label>
                                          </Checkbox>
                                        </>
                                      );
                                    } else {
                                      return (
                                        <>
                                          <Checkbox
                                            onClick={this.toggleChecked1.bind(
                                              this
                                            )}
                                            checked=""
                                            id="all1"
                                          >
                                            <label
                                              for="all1"
                                              className="select-all"
                                            >
                                              SELECT All{" "}
                                            </label>
                                          </Checkbox>
                                        </>
                                      );
                                    }
                                  })()}
                                </div>
                                <div class="row">
                                  {this.state.division_list.map((list) => (
                                    <div class="col m3 s6 d-contents mob-d-block">
                                      <Checkbox
                                        name="division_id[]"
                                        value={list.id}
                                        id={`div_${list.id}`}
                                        checked={this.state.selected_div.find(
                                          (ch) => ch === list.id
                                        )}
                                        onChange={(e) =>
                                          this.handleCheckbox1(e, list.id)
                                        }
                                      >
                                        <label
                                          for={`div_${list.id}`}
                                          className="checked"
                                        >
                                          <div class="center">{list.name}</div>
                                        </label>
                                      </Checkbox>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </Modal>
                          </Panel>
                        </Collapse>
                      </div>
                      <div class="children mb-20  iq-card2">
                        <Collapse defaultActiveKey={["1"]} onChange={callback}>
                          <Panel
                            header="Children"
                            classname="as bg-color-1"
                            key="1"
                          >
                            <Button
                              className="snd-btn"
                              onClick={this.showModal}
                            >
                              {" "}
                              Select Child
                            </Button>
                            <div class="children bg-blue attendance">
                              <Checkbox.Group name="children_id[]">
                                {this.state.selected_student_data.map(
                                  (list) => (
                                    <Checkbox
                                      value={list.id}
                                      id={list.first_name}
                                      defaultChecked={true}
                                      disabled
                                    >
                                      <label class="w-m" for={list.first_name}>
                                        <div class="center">
                                          {(() => {
                                            if (list.profile_pic != "") {
                                              return (
                                                <img
                                                  src={list.profile_pic}
                                                  class="atd-img user-profile-pic"
                                                />
                                              );
                                            } else {
                                              return (
                                                <img
                                                  src={person}
                                                  class="atd-img"
                                                />
                                              );
                                            }
                                          })()}{" "}
                                          {list.first_name} {list.last_name}
                                        </div>
                                      </label>
                                    </Checkbox>
                                  )
                                )}
                              </Checkbox.Group>
                            </div>
                            <Modal
                              title="Select Child"
                              visible={this.state.staff}
                              onOk={this.handleOk}
                              onCancel={this.handleCancel}
                              className="children-model"
                            >
                              <div class="children bg-blue attendance">
                                <div class="col-md-12">
                                  {(() => {
                                    if (this.state.checked == true) {
                                      return (
                                        <>
                                          <Checkbox
                                            onClick={this.toggleUnChecked.bind(this)}
                                            checked="checked"
                                            id="all"
                                          >
                                            <label
                                              for="all"
                                              className="select-all"
                                            >
                                              UNSELECT All{" "}
                                            </label>
                                          </Checkbox>
                                        </>
                                      );
                                    } else {
                                      return (
                                        <>
                                          <Checkbox
                                            onClick={this.toggleChecked.bind(this)}
                                            checked=""
                                            id="all"
                                          >
                                            <label
                                              for="all"
                                              className="select-all"
                                            >
                                              SELECT All{" "}
                                            </label>
                                          </Checkbox>
                                        </>
                                      );
                                    }
                                  })()}
                                </div>
                                <div class="row">
                                  {this.state.school_list.map((list) => (
                                    <div class="col-md-3 d-contents mob-d-block">
                                      <Checkbox
                                        name="checked_id[]"
                                        value={list.id}
                                        id={`child_${list.id}`}
                                        checked={this.state.checkedBoxes.find(
                                          (ch) => ch === list.id
                                        )}
                                        onChange={(e) =>
                                          this.handleCheckbox(e, list.id)
                                        }
                                      >
                                        <label
                                          for={`child_${list.id}`}
                                          className="checked"
                                        >
                                          <div class="center">
                                            {(() => {
                                              if (list.profile_pic != "") {
                                                return (
                                                  <img
                                                    src={list.profile_pic}
                                                    class="atd-img user-profile-pic"
                                                  />
                                                );
                                              } else {
                                                return (
                                                  <img
                                                    src={person}
                                                    class="atd-img"
                                                  />
                                                );
                                              }
                                            })()}{" "}
                                            {list.first_name} {list.last_name}
                                          </div>
                                        </label>
                                      </Checkbox>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </Modal>
                          </Panel>
                        </Collapse>
                      </div>
                    </div>
                    <div class="children bg-blue communication iq-card2">
                      <Collapse defaultActiveKey={["1"]} onChange={callback}>
                        <Panel header="Type of Communications" key="1">
                          <Radio.Group
                            value={this.state.communication_type}
                            name="communication_type"
                            onChange={this.handleSizeChange}
                          >
                            {this.state.tag_name.map((list) => (
                              <Radio.Button
                                value={list.name}
                                id={`tag_${list.id}`}
                              >
                                {" "}
                                <label for={`tag_${list.id}`}>
                                  {list.name}
                                </label>
                              </Radio.Button>
                            ))}
                          </Radio.Group>
                        </Panel>
                      </Collapse>
                    </div>
                    
					
					{(this.state.communication_type== "Class work" || this.state.communication_type== "Home Work") ? (
					<div class={`children  mb-20 iq-card2 mh-400 mt-20`} >
						<table class="table white border-radius-4 pt-1 table_border admission dairy-table form-group">
							<thead>
								<tr>
									<th class="dairy-table-td">Subject</th>	
									<th class="dairy-table-td">Task</th>	
									<th>Details</th>
									<th class="dairy-table-td">Upload File</th>
									<th class="dairy-table-last-td">Action</th>
								</tr>
							</thead>
							<tbody >
								{class_array.map((row, index) => (
									<tr key={index}>
										<td>
											<Select className="" onChange={this.change_subject.bind(this,row.id)}  value={row.subject_id} >
												<Select.Option value="">Select Subject</Select.Option>
												{this.state.subject_list.map((list) => (
													<Select.Option value={list.id}>{list.name}</Select.Option>
												))}
											</Select>
										</td>
										<td>
											<Select className="form-control old-ddl" onChange={this.change_task.bind(this,row.id)}  value={row.task} >
												<Select.Option value="">Select Task</Select.Option>
												<Select.Option value="Oral">Oral</Select.Option>
												<Select.Option value="Written">Written</Select.Option>
												<Select.Option value="Activity">Activity</Select.Option>
											</Select>
										</td>
										<td>
											<TextArea
											    autoSize={{ minRows: 2, maxRows: 6 }}
											    onChange={this.change_note.bind(this,row.id)}
												name="note"
												id="note"
												defaultValue={row.note}
											/>
										</td>
										<td>
											<div class="col-md-12 no-padd">
												<label class="ant-btn snd-btn ipt-10" for={`file_${row.id}`} id={`file_preview_${row.id}`}>Choose File</label>
												<input id={`file_${row.id}`} type="file" accept=".pdf,image/*" name="file" onChange={this.change_file.bind(this,row.id)} style={{display: 'none',opacity: '0'}}/>	
											</div>
										</td>
										<td>
											
															{(() => {
																if (index > 0) {
																return (
																	<div class="" style={{'display':'-webkit-inline-box'}}>
																	  <div class="col-md-12 text-left no-padd ">
																			<Button className="ant-btn btn btn-primary new-btn remove-btn ml-0 mb-0 float-left" onClick={this.removeRow.bind(this,this.state.row_id)}><CloseOutlined /></Button>
																		</div>
																	</div>
																	)
																}
															})()}
													
										</td>
									</tr>
								))}
								 
								<tr>
									<td class="center" colspan="6">
										<div class="" style={{'display':'-webkit-inline-box'}}>
										  <div class="col-md-12 text-center add-btn text-left no-padd">
												<Button className="ant-btn btn btn-primary new-btn ml-0 mb-0 float-left" onClick={this.addRow.bind(this,this.state.row_id)} ><PlusOutlined />Add</Button>
											</div>
										</div>
									</td>
								</tr>
							</tbody>	
						</table>
					</div>   
					):(<>
						<div class="col-md-12 mt-20">
						  <div class="meal mt-10 mb-20 pb-20">
							<div class="row">
							  <div class="col-md-10 no-padd">
								<TextArea
								  placeholder="Enter Details Here !!"
								  autoSize={{ minRows: 2, maxRows: 6 }}
								  onChange={this.handleSizeChange}
								  name="details"
								  id="details"
								/>
							  </div>
							  <div class="col-md-2 desktop-view">
								<Popover content={content} trigger="click">
								  <img src={attached} class="" alt="image" />
								</Popover>
							  </div>
							</div>
						  </div>
						</div>
						<div class="view-Profile col-md-12 mt-20 mb-20 w-100">
						  <div class="mb-20 pb-20 bb photos d-flow-root">
							<div class="upload-gallery " id="img_view">
							  <div class="col-md-12">
								{this.state.file_list.map((img) => (
								  <>
									{(() => {
									  return (
										<div class="ant-upload-list ant-upload-list-picture-card">
										  <div class="ant-upload-list-item ant-upload-list-item-done">
											<div class="ant-upload-list-item-info">
											  {/* <label>{img.file_name}</label>	*/}
											  <ModalImage
												small={img.file_url}
												large={img.file_url}
												hideDownload="true"
											  />
											  <button
												class="remove"
												id="remove"
												data-file={img.file_name}
												onClick={this.removeFile.bind(
												  this,
												  img.file_name
												)}
												type="button"
												title="Remove"
											  >
												<CloseOutlined />
											  </button>
											</div>
										  </div>
										</div>
									  );
									})()}
								  </>
								))}
							  </div>
							  <div class="col-md-12">
								{this.state.file_list_pdf.map((img) => (
								  <>
									{(() => {
									  return (
										<div class="ant-upload-list ant-upload-list-picture-card pdf">
										  <div class="ant-upload-list-item ant-upload-list-item-done">
											<div class="ant-upload-list-item-info">
											  <img class="file_icon" src="/assets/icons/pdf_icon.png"/>
											  <label>{img.file_name}</label>
											  <button
												class="remove"
												id="remove"
												data-file={img.file_name}
												onClick={this.removeFilepdf.bind(
												  this,
												  img.file_name
												)}
												type="button"
												title="Remove"
											  >
												<CloseOutlined />
											  </button>
											</div>
										  </div>
										</div>
									  );
									})()}
								  </>
								))}
							  </div>
							  <div class="col-md-12">
								{this.state.file_list_audio.map((img) => (
								  <>
									{(() => {
									  return (
										<div class="ant-upload-list ant-upload-list-picture-card pdf">
										  <div class="ant-upload-list-item ant-upload-list-item-done">
											<div class="ant-upload-list-item-info">
											  <img class="file_icon" src="/assets/icons/audio_file.png"/>
											  <label>{img.file_name}</label>
											  <button
												class="remove"
												id="remove"
												data-file={img.file_name}
												onClick={this.removeFileaudio.bind(
												  this,
												  img.file_name
												)}
												type="button"
												title="Remove"
											  >
												<CloseOutlined />
											  </button>
											</div>
										  </div>
										</div>
									  );
									})()}
								  </>
								))}
							  </div>
							</div>
						  </div>
						</div>
					</>)}		
					
					
                    <div class="col-md-12 meal  mb-20 center">
                      <Button
                        className="ant-btn btn btn-secondry mr-2"
                        onClick={this.goBack}
                      >
                        Back
                      </Button>
                      <Button
                        className="ant-btn btn  btn-primary mr-2"
                        onClick={this.handleSubmit}
                        loading={this.state.loading}
                      >
                        Save
                      </Button>
                    </div>
                  </section>
                </div>
                <div class="content-overlay"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Index;